<template>
  <v-card>
    <v-card-text>
      <h3>Astronomical</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'parsec',
          val: 1
        },
        {
          text: 'astronomical unit (AU)',
          val: 206264.8077366
        },
        {
          text: 'kilometer (km)',
          val: 30856776029500
        },
        {
          text: 'meter (m)',
          val: 30856776029500000
        },
        {
          text: 'mile (mi)',
          val: 19167794603220
        },
        {
          text: 'light-year (Julian)',
          val: 3.2615638
        },
        {
          text: 'light-year (Gregorian)',
          val: 3.261630773938
        },
        {
          text: 'light-year (traditional)',
          val: 3.263797747808
        },
        {
          text: 'light-year (tropical / solar)',
          val: 3.261633463758
        },
        {
          text: 'light-week',
          val: 170.1837397071
        },
        {
          text: 'light-day',
          val: 1191.28617795
        },
        {
          text: 'light-hour',
          val: 28590.8682708
        },
        {
          text: 'light-minut',
          val: 1715452.096248
        },
        {
          text: 'light-second',
          val: 102927125.7749
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// astronomical.vue?60b60ec5